import axios from 'axios';
import {  getStore,removeStore ,delCookie, setStore} from '../utils/util';
import store from '../vuex/store';
import $router from '@/router'
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    // timeout: 10000,
    headers:{
        'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
  // request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token  Authorization: localStorage.getItem('logintoken'),
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    if (getStore('logintoken') && !isToken) {
      config.headers['Authorization'] = getStore('logintoken') // 让每个请求携带自定义token
    }
    return config
  }, error => {
      console.log(error)
      Promise.reject(error)
  })
// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.rsp_code;
//     debugger;
//     // 二进制数据则直接返回
    // if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
    //     return res.data
    //   }
    if(code==401){
        setStore('userInfo','')
        setStore('roleRouter','')
        $router.push({ path: '/login' })
    }
else{
        return res.data
    }
  },err=>{
    return Promise.reject(err)
  }

)
// 登录请求方法
const loginreq = (method, url, params) => {
    return service({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
    });
};

// 获取验证码请求方法
const captcha = (method, url, params) => {
    return service({
        method: method,
        url: url,
        responseType: 'blob',
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    });
};
// 上传文件请求方法
const upload = (method, url, params) => {
    return service({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'multipart/form-data',
             Authorization: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
    });
};
// 上传文件请求方法
const exportExcel = (method, url, params) => {
    return service({
        method: method,
        url: url,
        responseType : 'blob', // 重要
        headers: {
             Authorization: localStorage.getItem('logintoken')
        },
        params: params,
        timeout: 0,
        traditional: true,
    });
};
// 通用公用方法
const req = (method, url, params) => {
    return service({
        method: method,
        url: url,
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    })
};
// get请求带对象参数公共方法
const getByobj = (method, url, params) => {
	return service({
		method: method,
		url: url, // 目标地址
		params: params
	})
}
// post请求带对象参数公共方法
const postByobj = (method, url, params) => {
	return service({
		method: method,
		url: url, // 目标地址
		query: params
	})
}
// post请求带对象参数公共方法
const postobj = (method, url, params) => {
	return service({
		method: method,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
		url: url, // 目标地址
		data: params
	})
}
export {
    loginreq,
    req,
    upload,
    captcha,
    getByobj,
    postByobj,
    postobj,
    exportExcel
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js